import { Router, NavigationExtras } from '@angular/router';
import { Injectable } from '@angular/core';
import { ItemObject } from 'src/app/models/orders/item/item-object.model';
import { OrderTypeObject } from 'src/app/models/orders/order-type-object.model';

@Injectable({
    providedIn: 'root'
})
export class OrdersRouterService {

    constructor(private router: Router) { }

    public navigate(item: ItemObject) {
        const navigationExtras: NavigationExtras = {
            queryParams: {
                id: item.crmId,
                map: item.orderId,
                type: item.type.urlPath,
                tab: item.tab.name
            }
        };
        if (!item.type.equals(OrderTypeObject.UNKNOWN)) {
            this.router.navigate([item.url], navigationExtras);
        };
    }

}
